// OAuth configuration - environment-specific
export const OAUTH_CONFIG = {
	authorizationUrl: 'https://aggmaps.com/oauth/v2/authorize',
	clientId: 'gsS9GwYmumOF1JvFLVoGYPUJGqDuq9Jo',
	redirectUri: 'truckscalepro://auth/callback',
	scope: [],
	// Note: client_secret is only available in Electron main process for security
};

// Helper function to detect Electron environment
export const isElectronEnvironment = () => {
	return window && window.electronAPI;
};

// Dynamic getters for environment detection
export const isElectron = {
	get value() {
		return isElectronEnvironment();
	}
};

export const requiresBackendProxy = {
	get value() {
		return !isElectronEnvironment();
	}
};
